import React from "react";
import ReactDOM from "react-dom";
import { Dialog } from "material-ui";

import { getIframePageInfoOnce } from "../../util";

const bodyStyle = {
  fontSize: 13,
  color: "#000"
};
const bodyStyleSlim = {
  overflowY: "visible"
};
const rootStyle = {
  overflowY: "scroll",
  background: "rgba(0, 0, 0, 0.541176)"
};
const contentStyle = {
  position: "relative",
  width: "90%",
  paddingBottom: 74
};
const overlayStyle = {
  position: "absolute",
  background: "none"
};

class BaseOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      previousEmbedScrollTop: null
    };
  }

  static contextTypes = {
    isEmbed: React.PropTypes.bool,
    portalClassName: React.PropTypes.string
  };

  _scrollIframe() {
    const _scroll = () => {
      getIframePageInfoOnce(({ scrollTop }) => {
        this.setState({
          previousEmbedScrollTop: scrollTop
        });

        // If content node isn't mounted, die. This means that the callback fired
        // after the user navigated already away from the modal, so we shouldn't do
        // anything.
        if (!this.contentNode) {
          return;
        }

        let boundingRect = this.contentNode.getBoundingClientRect();
        if (!boundingRect) {
          return;
        } // Same edge case as above

        const dest = Math.max(boundingRect.top - 200, 0);
        window.parentIFrame.scrollToOffset(0, dest);

        // Disable callback
        window.parentIFrame.getPageInfo(false);

        // Stop re-scrolling once we have gotten same result, otherwise retry
        if (dest === this._lastScrollIframeDest) {
          // fall through, success
        } else {
          this._lastScrollIframeDest = dest;
          this._iframeScrollTimeout = setTimeout(() => _scroll(), 500);
        }
      });
    };

    this._iframeScrollTimeout = setTimeout(() => _scroll(), 250);
  }

  componentDidMount() {
    // Iframe autoscroll
    if (this.context.isEmbed && window.parentIFrame) {
      this._scrollIframe();
    }

    // Iframe auto resize add tag
    if (this.contentNode) {
      let parent = this.contentNode.parentNode.parentNode.parentNode;
      if (parent) {
        parent.setAttribute("data-iframe-height", "");
        if (window.parentIFrame) {
          window.parentIFrame.size();
        }
      }
    }

    // Modal dismissal
    // Handle tap on bottom padding (see contentStyle ^)
    // Without this, tap events on the bottom 74 px padding are lost and don't dismiss.

    if (!this.contentNode) {
      return;
    }

    setTimeout(() => {
      if (!this.contentNode) {
        return;
      }

      let content = this.contentNode.parentNode.parentNode,
        contentContainer = content.parentNode;

      contentContainer.addEventListener("click", e => {
        if (!content.contains(e.target) && this.props.onRequestClose) {
          e.preventDefault();
          e.stopPropagation();
          this.props.onRequestClose();
        }
      });
    }, 1000); // wait for container to mount before adding listener
  }

  componentWillUnmount() {
    window.clearTimeout(this._iframeScrollTimeout);
    if (this.context.isEmbed && this.state.previousEmbedScrollTop) {
      window.parentIFrame.scrollTo(0, this.state.previousEmbedScrollTop);
    }
  }

  render() {
    let {
      children,
      useMuiDefaultStyle,
      zIndex,
      className,
      ...others
    } = this.props;

    let dialogClassName = className || this.context.portalClassName;

    return (
      <Dialog
        open={true}
        bodyStyle={!useMuiDefaultStyle ? bodyStyle : bodyStyleSlim}
        style={Object.assign({}, rootStyle, zIndex && { zIndex })}
        contentStyle={Object.assign(
          {},
          contentStyle,
          zIndex && { zIndex: zIndex + 1 }
        )}
        overlayStyle={Object.assign({}, overlayStyle, zIndex && { zIndex })}
        autoDetectWindowHeight={false}
        className={`Eventive--Dialog ${dialogClassName}`}
        bodyClassName={"eventive-content-container"}
        paperClassName={"eventive-background-container"}
        {...others}
      >
        <div
          ref={r => {
            this.contentNode = r;
          }}
        >
          {this.props.children}
        </div>
      </Dialog>
    );
  }
}

export default BaseOverlay;



// WEBPACK FOOTER //
// ./src/app/components/overlays/base.jsx